import React , { useContext } from 'react';
import classes from './NavigationItems.module.css';
import NavigationItem from './NavigationItem/NavigationItem';
import AuthContext from '../../../store/auth-context';

const NavigationItems = ( props ) => {

    const authCtx = useContext(AuthContext);
    
    return (
        <ul className={classes.NavigationItems}>
            <NavigationItem link='/' exact>store</NavigationItem>
            {authCtx.isLoggedIn && <NavigationItem link='/cart' >cart</NavigationItem> }
            {authCtx.isLoggedIn && <NavigationItem link='/orders' >orders</NavigationItem> }
            {!authCtx.isLoggedIn
            ? <NavigationItem link='/auth' >login</NavigationItem>
            : <NavigationItem link='/logout' >logout</NavigationItem> }
        </ul>
    )
};

export default NavigationItems;